import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
 
// 用来存储数据
const state = {
    //风机编号
    name:'',
    name1:"",
    // 风场编号
    factoryId:"",
    // 当前页面所在路径
    newPath:'',
    // 控制进度条的显示隐藏
    progress:true,
    // 保存风电场机群线列表数据
    fansList:[]

}
// 响应组件中的事件
const actions = {
 
}
// 操作数据
const mutations = {
    M_name(state,plyload){
        state.name = plyload
    },
    M_name1(state,plyload){
        state.name1 = plyload
    },
    M_factoryId(state,plyload){
        state.factoryId = plyload
    },
    M_newPath(state,plyload){
        state.newPath = plyload
    },
    M_progress(state,plyload){
        state.progress = plyload
    }
 
}
// 用来将state数据进行加工
const getters = {
 
}
// 新建并暴露store
export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters
})
 